import { createContext, useContext, useMemo } from 'react';
import type { FC } from 'react';

import { config } from '../../config';
import type { Vendor } from '../../types';

const VendorContext = createContext<{ vendor: Vendor }>(undefined!);

interface VendorProviderProps {
  vendor: Vendor;
}

export const VendorProvider: FC<VendorProviderProps> = ({
  vendor,
  children,
}) => {
  const state = useMemo(() => {
    return {
      vendor,
    };
  }, [vendor]);

  return (
    <VendorContext.Provider value={state}>{children}</VendorContext.Provider>
  );
};

const fallback = {
  vendor: config.provider,
};

export const useVendor = () => useContext(VendorContext) ?? fallback;
